var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup14456(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.087,
    height: 22.436,
    viewBox: "0 0 28.087 22.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14456",
    "data-name": "Group 14456",
    transform: "translate(11300.587 22448.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14391",
    "data-name": "Group 14391",
    transform: "translate(-7.795 -72.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M-11275.653-22373.193h9.948v18.645h-26.087v-14.887h11.128Z",
    fill: "none",
    stroke: "#e99400",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M-11288.931-22369.555v-5.43h7.542l3.434,3.434",
    fill: "none",
    stroke: "#e99400",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-right",
    "data-name": "Icon awesome-arrow-alt-circle-right",
    d: "M4.055.563A3.492,3.492,0,1,1,.563,4.055,3.492,3.492,0,0,1,4.055.563ZM2.421,4.674H4.055v1a.169.169,0,0,0,.289.12l1.61-1.618a.167.167,0,0,0,0-.238L4.343,2.317a.169.169,0,0,0-.289.12v1H2.421a.169.169,0,0,0-.169.169v.9A.169.169,0,0,0,2.421,4.674Z",
    transform: "translate(-11290.598 -22439.555)",
    fill: "#e99400"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup14456);
export default __webpack_public_path__ + "static/media/Group 14456.b207f6cf574bafe98fd861ce791d6c6d.svg";
export { ForwardRef as ReactComponent };